import React, { useState } from "react";
import InputMask from "react-input-mask";
import TextField from "@material-ui/core/TextField";
import moment from "moment";

/* Properties

   mask:
   maskChar:
   defaultValue:
   formatChars:
   alwaysShowMask:
   formatChars={{'a':'[A-Z]', '9':'[0-9]'}}
   allowNull
*/

const MaskedTime = (props) => {
  const validateTime = (time) => {
    if (props.allowNull && (time == null || time === "")) return null;

    let hour = time.substr(0, 2).trim();
    let minute = time.substr(3, 2).trim();

    if (hour.length < 2)
      hour = "00".substr(0, "00".length - hour.length) + hour;
    if (parseInt(hour) > 23) return "  :  ";
    if (minute === "") minute = "00";
    if (parseInt(minute) > 59) minute = "59";
    if (minute.length < 2) {
      if (parseInt(minute) < 6) minute += "0";
      else minute = "0" + minute;
    }

    if (props.quarterHour && props.quarterHour === true) {
      let intMinute = parseInt(minute);
      const remainder = intMinute % 15;
      if (remainder < 8) intMinute -= remainder;
      else intMinute += 15 - remainder;

      minute = intMinute.toString();
      minute = "00".substr(0, "00".length - minute.length) + minute;
    }

    return hour + ":" + minute;
  };
  const [state, setState] = useState({
    propsValue: JSON.stringify(props.value),
    value:
      props.source === "timestamp"
        ? moment.utc(props.value).format("HH:mm")
        : props.value,
  });
  if (state.propsValue !== JSON.stringify(props.value)) {
    setState({
      propsValue: JSON.stringify(props.value),
      value:
        props.source === "timestamp"
          ? moment.utc(props.value).format("HH:mm")
          : props.value,
    })
  }

  const handleChangeComplete = (event) => {
    if (props.readOnly)
      return;
    setState({ ...state, value: event.target.value });
    props.onChange(event.target.value);
  };

  if (!props.value && props.defaultValue) {
    props.onChange(props.defaultValue);
  }

  const handleOnBlur = (event) => {
    // console.log("Blur value:", event.target.value, event.target.value.length);
    if (props.readOnly)
      return;
    const validTime = validateTime(event.target.value);
    console.log(validTime);
    setState({ ...state, value: validTime });
    if (
      props.source === "timestamp" &&
      (!props.allowNull || validTime != null)
    ) {
      let timeStampDate = `${moment.utc().format("YYYY-MM-DD")} ${validTime}:00`;
      if (moment.utc(props.value).isValid()) {
        timeStampDate = `${moment.utc(props.value).format(
          "YYYY-MM-DD"
        )} ${validTime}:00`;
      }
      if (props.relativeTimestamp) {
        timeStampDate = `${moment.utc(props.relativeTimestamp).format(
          "YYYY-MM-DD"
        )} ${validTime}:00`;
        const diff = moment.utc(timeStampDate).diff(
          moment.utc(props.relativeTimestamp),
          "hours",
          true
        );
        if (
          diff < (props.relativeOffset || -5) &&
          diff < 0 &&
          moment.utc(props.relativeTimestamp).hour() >= 19
        ) {
          timeStampDate = moment.utc(timeStampDate)
            .add(1, "days")
            .toISOString();
//            .format("YYYY-MM-DD HH:mm:ss");
        } else if (
          diff > (props.relativeOffset || 5) &&
          moment.utc(props.relativeTimestamp).hour() < 5
        ) {
          timeStampDate = moment.utc(timeStampDate)
            .add(-1, "days")
            .toISOString();
//            .format("YYYY-MM-DD HH:mm:ss");
        } else if (
          diff < (props.relativeOffset || -9) &&
          moment.utc(props.relativeTimestamp).hour() >= 8
        ) {
          timeStampDate = moment.utc(timeStampDate)
            .add(1, "days")
            .toISOString();
//            .format("YYYY-MM-DD HH:mm:ss");
        }
      }
      console.log(props.relativeTimestamp, timeStampDate);
      props.onChange(timeStampDate);
    } else {
      props.onChange(validTime);
    }
  };

  let inputProps = {...props.inputProps};
  let classNames = Array.isArray(props.className)?[...props.className]:[props.className]
  if (props.readOnly) {
    inputProps.readOnly = true;
    if (Array.isArray(inputProps.className)){
      inputProps.className = [...inputProps.className, 'readOnly'].join(' ');
    } else {
      inputProps.className = [inputProps.className, 'readOnly'].join(' ');
    }
    classNames.push('readonly');
  }
  const className = classNames.join(' ');

  return (
    <div style={{ ...props.style }} >
      <InputMask
        value={state.value}
        mask={"99:99"}
        alwaysShowMask={props.alwaysShowMask || false}
        maskChar={props.maskChar || " "}
        defaultValue={props.defaultValue || ""}
        onChange={handleChangeComplete}
        onBlur={handleOnBlur}
        label={props.label}
        InputLabelProps={{
          disabled: props.disabled,
          ...props.inputLabelProps,
        }}
        disabled={props.disabled}
        readOnly={props.readOnly}
      >
        {() => <TextField
                className={className}
                InputProps={inputProps}
                inputProps={inputProps}
                label={props.label}
                InputLabelProps={{
                  disabled: props.disabled,
                  ...props.inputLabelProps
                }}
                id={props.id}
                style={props.style}
                fullWidth={props.fullWidth}
                disabled={props.disabled}
              />}
      </InputMask>
    </div>
  );
};

export default MaskedTime;
